// Minimal history-based SPA router (clean URLs, matching the React admin's BrowserRouter — so
// bookmarks and the nginx try_files fallback are unchanged). Owns just what a fixed, known route
// set needs: `:param` matching + lazy chunk loading. No external router dependency.

export const router = $state({ path: window.location.pathname });

window.addEventListener("popstate", () => {
  router.path = window.location.pathname;
});

export function navigate(to, { replace = false } = {}) {
  if (to === router.path) return;
  if (replace) window.history.replaceState({}, "", to);
  else window.history.pushState({}, "", to);
  router.path = to;
}

// Compiles a route pattern like "/aml-screenings/:tab" into a matcher returning captured params.
function compile(pattern) {
  const names = [];
  const regexSource = pattern
    .split("/")
    .map((seg) => {
      if (seg.startsWith(":")) {
        names.push(seg.slice(1));
        return "([^/]+)";
      }
      return seg.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    })
    .join("/");
  const regex = new RegExp(`^${regexSource}/?$`);
  return (path) => {
    const m = regex.exec(path);
    if (!m) return null;
    const params = {};
    names.forEach((n, i) => (params[n] = decodeURIComponent(m[i + 1])));
    return params;
  };
}

// Resolves the first matching route in `routes` for `path`. Returns { route, params } or null.
export function matchRoute(routes, path) {
  for (const route of routes) {
    const params = compile(route.path)(path);
    if (params) return { route, params };
  }
  return null;
}
